export default "__VITE_ASSET__76526a08__"